import { useMutation } from '@tanstack/react-query';
import Cookies from 'js-cookie';

import { ADMIN_AUTH_COOKIE_NAME } from '@constants';
import { showErrorToast } from '@hooks/showErrorToast';

export const useAdminSignOut = (callback: () => void) => {
  return useMutation({
    mutationFn: async () => {
      Cookies.set(ADMIN_AUTH_COOKIE_NAME, '');
    },
    onSuccess: () => {
      callback();
    },
    onError: (error) => {
      showErrorToast(error, `Sign out failed!`);
    },
  });
};
